// extracted by mini-css-extract-plugin
export default {"notice":"SearchNotice_notice__3aiuH","icon":"SearchNotice_icon__5KssJ","text":"SearchNotice_text__JNjlD","clear":"SearchNotice_clear__qVPqc"};